<template>
    <section class="container">
        <div class="row">
            <div class="col">
                <div class="notice-card">
                    <div class="notice-header-row">
                        <h2 class="notice-title">공지사항 상세</h2>
                        <div class="notice-meta">
                            <span class="notice-meta-item"><i class="fa fa-calendar"></i> {{notice.modifiedDate}}</span>
                            <span class="notice-meta-item"><i class="fa fa-eye"></i> 조회수: {{notice.viewCount}}</span>
                        </div>
                    </div>
                    <div v-if="notice">
                        <div class="notice-box">
                            <div class="notice-title-row">
                                <h3 class="notice-post-title">{{notice.title}}</h3>
                            </div>
                            <div class="notice-content" v-html="notice.content"></div>
                        </div>
                        <div class="notice-actions-row" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">
                            <div class="notice-admin-actions">
                                <router-link :to="{name : 'noticeModified', params : { id : notice.id }}" class="btn btn-primary">
                                    <i class="fa fa-edit"></i> 수정
                                </router-link>
                                <button type="button" v-on:click="deleteCheck()" class="btn btn-danger">
                                    <i class="fa fa-trash"></i> 삭제
                                </button>
                            </div>
                        </div>
                        <div class="notice-navigation">
                            <div class="notice-nav-item" v-if="next != null">
                                <button type="button" v-on:click="getNearArticles(next.id)" class="btn btn-outline-primary">
                                    <i class="fa fa-chevron-down"></i> 다음글: {{next.title}}
                                </button>
                            </div>
                            <div class="notice-nav-item" v-if="prev != null">
                                <button type="button" v-on:click="getNearArticles(prev.id)" class="btn btn-outline-primary">
                                    <i class="fa fa-chevron-up"></i> 이전글: {{prev.title}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="notice-footer-row">
                        <button type="button" v-on:click="goList()" class="btn btn-dark btn-list">목록으로</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import adminSidenav from '@/components/admin/Sidenav.vue'

    export default {
        name: 'NoticeShow',
        components: {adminSidenav},
        data() {
            return {
                notice : {},
                next : {},
                prev : {},
            }
        },
        methods: {
            deleteCheck() {
                this.popupToggle(`확인`, `이 공지를 삭제 하시겠습니까?`, this.deleteContents)
            },
            deleteContents() {
                let me = this;
                this.axios.delete(process.env.VUE_APP_NOTICE_API_URL + `/${me.$route.params.id}`)
                    .then(function (res) {
                        me.$root.$children[0].commonDialog('공지사항','삭제 되었습니다.');
                        me.goList();
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            getNearArticles(id) {
                let me = this;
                this.axios.get(process.env.VUE_APP_NOTICE_API_URL + `/near/${id}`)
                    .then(function (res) {
                        me.next = res.data.next;
                        me.prev = res.data.prev;
                        me.notice = res.data.now;
                    }).catch(function (error) {
                    console.log(error);
                });
            },
            goList() {
                this.$router.push({name:'notice'});
            },
            popupToggle(title, text, callback) {
                this.$modal.show('dialog', {
                    title: title,
                    text: text,
                    buttons: [
                        {
                            title: title,
                            handler: () => {
                                callback();
                                this.$modal.hide('dialog');
                            }
                        },
                        {
                            title: '취소'
                        },
                    ]
                })
            },
        },
        mounted() {
            this.getNearArticles(this.$route.params.id)
        },
    }
</script>
<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.notice-card {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  padding: 32px 24px 24px 24px;
  margin-top: 24px;
  margin-bottom: 24px;
}

.notice-title {
  font-size: 1.5em;
  font-weight: 700;
  margin-bottom: 18px;
  color: #2c3e50;
  letter-spacing: -1px;
}

.notice-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.notice-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-size: 0.98em;
  color: #888;
}

.notice-meta-item {
  margin-left: 0;
  margin-bottom: 2px;
}

.notice-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.notice-post-title {
  font-size: 1.25em;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #2c3e50;
}

.notice-box {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 18px;
  margin-bottom: 18px;
}

.notice-content {
  font-size: 1.08em;
  color: #222;
  margin-top: 16px;
  line-height: 1.7;
  word-break: break-all;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #2c3e50;
}

.notice-actions-row {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.notice-admin-actions {
  display: flex;
  gap: 16px;
}

.btn-primary {
  background-color: #2c3e50;
  border-color: #2c3e50;
  color: white;
  padding: 8px 20px;
  border-radius: 6px;
  text-decoration: none;
  display: inline-block;
  transition: all 0.3s ease;
  font-size: 15px;
  min-width: 90px;
  box-sizing: border-box;
}

.btn-primary:hover {
  background-color: #1a252f;
  border-color: #1a252f;
  color: white;
  text-decoration: none;
}

.btn-danger {
  background-color: #e74c3c;
  border-color: #e74c3c;
  color: white;
  padding: 8px 20px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 15px;
  min-width: 90px;
  box-sizing: border-box;
}

.btn-danger:hover {
  background-color: #c0392b;
  border-color: #c0392b;
  color: white;
}

.notice-navigation {
  margin: 20px 0;
}

.notice-nav-item {
  margin-bottom: 8px;
}

.btn-outline-primary {
  color: #2c3e50;
  border-color: #2c3e50;
  background: none;
  padding: 10px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 14px;
  text-align: left;
  width: 100%;
}

.btn-outline-primary:hover {
  background-color: #2c3e50;
  border-color: #2c3e50;
  color: white;
}

.notice-footer-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}

.btn-list {
  min-width: 110px;
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-list:hover {
  background-color: #5a6268;
  border-color: #5a6268;
  color: white;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 2px;
  }
  .notice-card {
    padding: 10px 4px;
    border-radius: 0;
    box-shadow: none;
  }
  .notice-post-title {
    font-size: 1.05em;
  }
  .notice-header-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .notice-meta {
    align-items: flex-start;
    font-size: 0.95em;
  }
  .notice-content {
    padding: 16px;
    font-size: 1em;
  }
  .notice-actions-row {
    padding: 12px;
  }
  .notice-admin-actions {
    flex-direction: column;
    width: 100%;
  }
  .btn-primary, .btn-danger {
    width: 100%;
    text-align: center;
  }
  .notice-footer-row {
    margin-top: 16px;
  }
  .btn-list {
    min-width: 100%;
    font-size: 1em;
    padding: 10px 0;
  }
}
</style>